"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BookingEmptyState: function() {
        return _bookingemptystatesvg.default;
    },
    BookingSuccess: function() {
        return _bookingsuccesssvg.default;
    },
    EmptyStateSearch: function() {
        return _emptystatesearchsvg.default;
    },
    HorizontalLoaderX: function() {
        return _horizontalloadersvg.default;
    },
    Loader: function() {
        return _loadingloadersvg.default;
    },
    LoaderLifestyleX: function() {
        return _loaderlifestylexsvg.default;
    },
    Login: function() {
        return _loginsvg.default;
    },
    LoginCode: function() {
        return _logincodesvg.default;
    },
    LoginSuccess: function() {
        return _loginsuccesssvg.default;
    },
    Traveler: function() {
        return _travelersvg.default;
    }
});
var _logincodesvg = /*#__PURE__*/ _interop_require_default(require("./login-code.svg"));
var _loginsuccesssvg = /*#__PURE__*/ _interop_require_default(require("./login-success.svg"));
var _loginsvg = /*#__PURE__*/ _interop_require_default(require("./login.svg"));
var _travelersvg = /*#__PURE__*/ _interop_require_default(require("./traveler.svg"));
var _emptystatesearchsvg = /*#__PURE__*/ _interop_require_default(require("./empty-state-search.svg"));
var _bookingsuccesssvg = /*#__PURE__*/ _interop_require_default(require("./booking-success.svg"));
var _bookingemptystatesvg = /*#__PURE__*/ _interop_require_default(require("./booking-empty-state.svg"));
var _loaderlifestylexsvg = /*#__PURE__*/ _interop_require_default(require("./loader-lifestylex.svg"));
var _loadingloadersvg = /*#__PURE__*/ _interop_require_default(require("./loading-loader.svg"));
var _horizontalloadersvg = /*#__PURE__*/ _interop_require_default(require("./horizontal-loader.svg"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
